import i18n from '@/helper/i18n';

export default function formatRole(value) {
  return i18n.te(`settings.companyUsers.roles.${value}`)
    ? i18n.t(`settings.companyUsers.roles.${value}`)
    : value;
}
